import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isOpen", "onChange", "onClose", "value", "theme"];
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Calendar from '../Calendar';
import withTheme from '../theme/withTheme';
import { Overlay, Wrapper, ModalActiveStyle, ButtonOk, ButtonClose, ButtonsContainer } from './DatePickerStyles';
var _ref2 = /*#__PURE__*/React.createElement(ModalActiveStyle, null);
var DatePicker = function DatePicker(_ref) {
  var isOpen = _ref.isOpen,
    onChange = _ref.onChange,
    onClose = _ref.onClose,
    value = _ref.value,
    theme = _ref.theme,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    selectedDate = _useState2[0],
    dateChangeHandler = _useState2[1];
  var isDateValid = function isDateValid(date) {
    return date instanceof Date && !isNaN(date);
  };
  useEffect(function () {
    dateChangeHandler(value);
  }, [value]);
  useEffect(function () {
    if (isOpen) {
      var date = isDateValid(value) ? value : new Date();
      dateChangeHandler(date);
    }
  }, [isOpen]);
  return isOpen ? /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(Overlay, null, _ref2, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Calendar, _extends({
    theme: theme,
    views: ['year', 'month', 'date'],
    value: selectedDate,
    onChange: function onChange(date) {
      return dateChangeHandler(date);
    }
  }, rest)), /*#__PURE__*/React.createElement(ButtonsContainer, null, /*#__PURE__*/React.createElement(ButtonClose, {
    theme: theme,
    onClick: function onClick() {
      return onClose();
    }
  }, "Fechar"), /*#__PURE__*/React.createElement(ButtonOk, {
    theme: theme,
    onClick: function onClick() {
      return onChange(selectedDate);
    }
  }, "Ok")))), document.body) : null;
};
export default withTheme(DatePicker);